// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx

// TODO: Check if the icon is alined properly.
// If it is not: Replace/extend defaultAlignedActionIconGroupProps to make it look right.
// https://stash.int.klarna.net/projects/UI/repos/bubble-ui/pull-requests/121/overview?commentId=2244923
import baseIcon, { defaultAlignedActionIconGroupProps } from '@bubble-ui/temp-icon-base';
var ActionIconUploadPath = 'M3 12h6c1.103 0 2-.897 2-2H1c0 1.103.897 2 2 2Zm5.828-6.757 1.415-1.414L6.707.293a1 1 0 0 0-1.414 0L1.757 3.83l1.415 1.414L5 3.415V8h2V3.415l1.828 1.828Z';
var ActionIconUpload = baseIcon('ActionIconUpload', {
  groupProps: defaultAlignedActionIconGroupProps,
  getPath: () => ActionIconUploadPath
});
export default ActionIconUpload;
//# sourceMappingURL=index.js.map